define.alias("shared/components/shared/addon-details-card", "calendar/components/shared/addon-details-card");